export default from './like-button';



// WEBPACK FOOTER //
// ./app/components/like-button/index.js